/**
 * Der ganze Kundendatensatz als Blatt von rechts — auf der Aufgabenseite und im
 * Nachrichtenfenster, ohne sie zu verlassen (Benjamin, 22.09.2026). Inhalt ist
 * dieselbe Ansicht wie auf der Kundenseite (`KundeAnsicht`, 03.10.2026): ihr Kopf
 * mit Name und Schließen-Knopf ist zugleich der Kopf des Blatts.
 */
import { useEffect } from "react";

import { useKunden } from "../../hooks/usePlanung";
import KundeAnsicht from "./KundeAnsicht";
import "../../styles/kunden.css";

type Props = { kundeId: string; onClose: () => void };

export default function KundeBlatt({ kundeId, onClose }: Props) {
  const { data: kunden = [], isLoading } = useKunden();
  const kunde = kunden.find((k) => k.id === kundeId) || null;

  useEffect(() => {
    const zu = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", zu);
    return () => window.removeEventListener("keydown", zu);
  }, [onClose]);

  return (
    <div className="k-blatt" role="dialog" aria-modal="true" aria-label={kunde ? `Kunde ${kunde.name}` : "Kunde"}>
      <button type="button" className="k-blatt-schleier" aria-label="Schließen" onClick={onClose} />
      <aside className="k-blatt-panel">
        <div className="k-blatt-inhalt k-blatt-ansicht">
          {isLoading && <p className="k-akte-leer">Lade …</p>}
          {!isLoading && !kunde && (
            <div className="k-blatt-fehlt">
              <p className="k-akte-leer">Diesen Kunden gibt es nicht mehr.</p>
              <button type="button" className="k-blatt-zu" aria-label="Schließen" onClick={onClose}>×</button>
            </div>
          )}
          {kunde && <KundeAnsicht key={kunde.id} kunde={kunde} onSchliessen={onClose} />}
        </div>
      </aside>
    </div>
  );
}
